import GcDropShadow from '../GcDropShadow/index.vue';
import GcHorizontalLayout from '../GcHorizontalLayout/index.vue';
import GcIcon from '../GcIcon/index.vue';

export default {
  name: 'GcCartCard',
  data() {
    return {
      className: 'gc__cart-card',
    };
  },
  components: {
    GcDropShadow,
    GcHorizontalLayout,
    GcIcon,
  },
  computed: {
    productImageWrapper() {
      return `${this.className}__product-image`;
    },
    productInfoHeadingWrapper() {
      return `${this.className}__product-info-heading`;
    },
    productNameClass() {
      return `${this.className}__product-name`;
    },
    productNumberClass() {
      return `${this.className}__product-number`;
    },
    iconWrapperClass() {
      return `${this.className}__icon-wrapper`;
    },
    iconImageClass() {
      return `${this.className}__icon-image`;
    },
    hasProductUrl() {
      return !!this.productUrl.length;
    },
    horizontalLayoutClass() {
      const layoutClass = `${this.className}__horizontal-layout`;
      const reverseLayoutClass = `${layoutClass}--reverse`;
      return [
        layoutClass,
        { [reverseLayoutClass]: this.reverseRow },
      ];
    },
    horizontalLayoutLeftClass() {
      return `${this.className}__horizontal-layout__left-side`;
    },
    horizontalLayoutRightClass() {
      return `${this.className}__horizontal-layout__right-side`;
    },
    productLink() {
      return this.hasProductUrl ? this.productUrl : null;
    },
    containerEl() {
      return this.hasProductUrl ? 'a' : 'div';
    },
    productUrlClassName() {
      return `${this.className}__product-url`;
    },
    productLinkText() {
      return this.productName;
    },
  },
  props: {
    productImage: {
      type: String,
    },
    productName: {
      type: String,
      default: '',
    },
    partNumber: {
      type: String,
      default: '',
    },
    disableHover: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    closeToolTip: {
      type: String,
      default: 'Remove',
    },
    reverseRow: {
      type: Boolean,
      default: false,
    },
    styleObject: {
      type: Object,
      default: null,
    },
    productUrl: {
      type: String,
      default: '',
    },
  },
};
